import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);
const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);
const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);
const socials = [
  {
    label: "YouTube",
    Icon: YouTubeIcon,
    color: "#FF0000",
    hoverColor: "#cc0000",
    url: "https://www.youtube.com/@artemclava",
  },
  {
    label: "LinkedIn",
    Icon: LinkedInIcon,
    color: "#0A66C2",
    hoverColor: "#084fa0",
    url: "https://www.linkedin.com/company/artem-calva/",
  },
  {
    label: "Instagram",
    Icon: InstagramIcon,
    color: "#E1306C",
    hoverColor: "#c1235a",
    url: "https://www.instagram.com/artemclava.india?igsh=dnVtd3Axa2lhM3Nv",
  },
];

function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(160deg, #120822 0%, var(--ink) 100%)",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "4px",
          background:
            "linear-gradient(90deg, var(--fuchsia), var(--gold), var(--teal), var(--lavender), var(--coral))",
        }}
      />
      <div
        style={{
          position: "absolute",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(214,36,110,0.08), transparent 70%)",
          top: "-200px",
          right: "-100px",
          pointerEvents: "none",
        }}
      />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{
          width: "90%",
          margin: "0 auto",
          padding: "70px 0 50px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "50px",
            marginBottom: "60px",
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "6px",
                marginBottom: "16px",
              }}
            >
              <span
                style={{
                  fontFamily: "var(--font-serif)",
                  fontStyle: "italic",
                  fontWeight: 900,
                  fontSize: "1.8rem",
                  color: "#fff",
                }}
              >
                ARTEM
              </span>
              <span
                style={{
                  fontFamily: "var(--font-hand)",
                  fontSize: "2rem",
                  color: "var(--gold)",
                }}
              >
                Clava
              </span>
            </div>
            <p
              style={{
                color: "rgba(255,255,255,0.55)",
                lineHeight: 1.8,
                fontWeight: 300,
                fontSize: "0.9rem",
              }}
            >
              Where creativity meets luxury. Transforming spaces into artistic
              experiences across India.
            </p>
            <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
              {socials.map((s) => (
                <motion.a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  whileHover={{ scale: 1.15, y: -4 }}
                  whileTap={{ scale: 0.95 }}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "rgba(255,255,255,0.08)",
                    border: `1.5px solid rgba(255,255,255,0.12)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: s.color,
                    cursor: "pointer",
                    textDecoration: "none",
                    transition: "background 0.3s, border-color 0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = s.color + "22";
                    e.currentTarget.style.borderColor = s.color + "88";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.08)";
                    e.currentTarget.style.borderColor =
                      "rgba(255,255,255,0.12)";
                  }}
                >
                  <s.Icon />
                </motion.a>
              ))}
            </div>
          </div>
          <div>
            <h4
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "1.1rem",
                color: "var(--gold)",
                marginBottom: "20px",
                fontStyle: "italic",
              }}
            >
              Quick Links
            </h4>
            {[
              { to: "/", label: "Home" },
              { to: "/about", label: "About" },
              { to: "/services", label: "Services" },
              { to: "/career", label: "Career" },
              { to: "/contact", label: "Contact" },
            ].map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                style={{
                  display: "block",
                  marginBottom: "10px",
                  textDecoration: "none",
                }}
              >
                <motion.span
                  whileHover={{ x: 6, color: "var(--gold)" }}
                  style={{
                    color: "rgba(255,255,255,0.55)",
                    fontWeight: 300,
                    fontSize: "0.9rem",
                    display: "inline-block",
                    transition: "color 0.3s",
                  }}
                >
                  → {label}
                </motion.span>
              </Link>
            ))}
          </div>
          <div>
            <h4
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: "1.1rem",
                color: "var(--teal)",
                marginBottom: "20px",
                fontStyle: "italic",
              }}
            >
              Services
            </h4>
            {[
              { label: "Wall Murals", to: "/services/wall-murals" },
              { label: "Wall Sculptures", to: "/services/wall-sculptures" },
              {
                label: "Fiber Glass & GRC Murals",
                to: "/services/fiberglass-grc",
              },
              { label: "Large Canvas", to: "/services/large-canvas" },
              {
                label: "Artistic Ventures",
                to: "/services/artistic-containers",
              },
              { label: "Facade & Glass Murals", to: "/services/facades-glass" },
            ].map((s) => (
              <Link
                key={s.label}
                to={s.to}
                style={{
                  display: "block",
                  color: "rgba(255,255,255,0.55)",
                  marginBottom: "10px",
                  fontWeight: 300,
                  fontSize: "0.9rem",
                  textDecoration: "none",
                  transition: "color 0.2s",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#c9982a")}
                onMouseLeave={(e) =>
                  (e.target.style.color = "rgba(255,255,255,0.55)")
                }
              >
                🎨 {s.label}
              </Link>
            ))}
          </div>
          <div>
            <h4
              style={{
                fontFamily: "var(--font-hand)",
                fontSize: "1.5rem",
                color: "var(--lavender)",
                marginBottom: "16px",
              }}
            >
              "Art is not what you see, but what you make others see."
            </h4>
            <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.8rem" }}>
              — Edgar Degas
            </p>
          </div>
        </div>
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            paddingTop: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <p
            style={{
              color: "rgba(255,255,255,0.4)",
              fontSize: "0.85rem",
              textAlign: "center",
              width: "100%",
            }}
          >
            © 2025 Artem Clava India. All rights reserved.
          </p>
          <div style={{ display: "flex", gap: "20px" }}>
            {["Privacy Policy", "Terms of Use"].map((t) => (
              <span
                key={t}
                style={{
                  color: "rgba(255,255,255,0.4)",
                  fontSize: "0.8rem",
                  cursor: "pointer",
                  transition: "color 0.3s",
                }}
              >
                {t}
              </span>
            ))}
          </div>
        </div>
      </motion.div>
    </footer>
  );
}
export default Footer;
